/**
 * Saves a generated file through a temporary anchor. The object URL is revoked
 * on the next tick, not synchronously: some browsers have not started reading the
 * blob when `click()` returns, and an early revoke cancels the download.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => URL.revokeObjectURL(url), 100)
}
